<template>
  <div class="goOutManage" v-if="permisShow('外出查看')">
    <div class="sales_header">
      <div class="chouse_wrap" style="display: flex;justify-content: space-between">
        <ul class="conditions_list">
          <li class="conditions_list_item total_price_input">
            <span>外出时间：</span>
            <span class="total_inp input_box">
              <el-date-picker v-model="searchData.outTime" unlink-panels value-format="yyyy-MM-dd" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change="currentPage=1,pageNumber=1,getGooutlist()"></el-date-picker>
            </span>
          </li>
          <li class="conditions_list_item" style="position: relative">
            <span>部门：</span>
            <div class="Residential">
              <el-input @focus="departpopshow=!departpopshow" v-model="searchData.shopname" placeholder="请选部门" clearable @clear="searchData.shopname='',searchData.shopId='',currentPage=1,pageNumber=1,getGooutlist()"></el-input>
            </div>
            <div class="departpop" v-show="departpopshow">
              <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                <span class="custom-tree-node" slot-scope="{data}">
                  <div>
                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                    <span>{{ data.name }}</span>
                  </div>
                </span>
              </el-tree>
            </div>
          </li>

          <li class="conditions_list_item">
            <span>人员：</span>
            <div class="Residential">
              <el-autocomplete class="select" popper-class="my-autocomplete" v-model="searchData.employeeName" :fetch-suggestions="querySearchAsync" placeholder="请选择" @select="handleSelect" clearable>
                <template slot-scope="{ item }">
                  <div class="name" @select="handleSelect">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </div>
          </li>
          <li class="conditions_list_item">
            <span>状态：</span>
            <el-select v-model="searchData.status" placeholder="请选择" @change="currentPage=1,pageNumber=1,getGooutlist()" clearable>
              <el-option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </li>

        </ul>
      </div>
    </div>
    <div class="sales_list_wrap">
      <el-table ref="multipleTable" :data="goOutLsit" border style="width: 100%;" @row-click="rowColorclick" highlight-current-row @row-dblclick="toDetails" :header-cell-style="setHeaderStyle">
        <el-table-column prop="outTime" label="外出时间"></el-table-column>
        <el-table-column prop="outEmployeeName" label="人员"></el-table-column>
        <el-table-column prop="outType" label="外出类型"></el-table-column>
        <el-table-column prop="outDemo" label="事由"></el-table-column>
<!--        <el-table-column prop="outNumber" label="预计时长（小时）"></el-table-column>-->
        <el-table-column prop="outNumber" label="实际用时"></el-table-column>
        <el-table-column prop="statusName" label="状态">
          <template slot-scope="scope">
            <span :style="{color:scope.row.statusName=='已返回'?'#00C473':'#FF464B'}" :class="{rowColor:scope.row.id===isRowColor}">{{scope.row.statusName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="returnTime" label="返回时间"></el-table-column>
        <el-table-column prop="outResult" label="外出结果"></el-table-column>
        <el-table-column prop="pictureIds" label="附件">
          <template slot-scope="scope">
            <div class="imgBox" @click.stop="openImglist(scope.row)">
              <img :src="'http://'+item" alt="附件" style="width:28px;height:28px;padding:0 4px;" v-for="(item,index) in scope.row.pictureIds" :key="index">
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
    </div>
    <div class="mask" v-if="imgListShow">
      <img class="close" @click="imgListShow=false" src="../../assets/images/close.png" alt />
      <template>
        <el-carousel indicator-position="outside" :autoplay='false'>
          <el-carousel-item v-for="(item,index) in imgList" :key="index">
            <img :src="'http://'+item" alt />
            <el-button class="download" v-if="ispc" @click="downLoadImg('http://'+item)" type="primary">下载</el-button>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <el-dialog title="外出详情" :visible.sync="dialogVisible" width="800px">
      <div class="details_contant">
        <div class="details_title">
          <div class="details_title_item" :class="{isActive:isActiveNum==index}" v-for="(item,index) in tabTitle" :key="index" @click="isActiveNum=index">{{item.name}}</div>
        </div>
        <ul class="details_body" v-if="isActiveNum==0">
          <li class="details_body_row">
            <div>
              <span>申请人：</span>
              <span>{{outManageData.outEmployeeName}}</span>
            </div>
            <div>
              <span>类<span style="visibility:hidden;">占位</span>型：</span>
              <span>{{outManageData.outTypeName}}</span>
            </div>
            <div>
              <span>状<span style="visibility:hidden;">占位</span>态：</span>
              <span>{{outManageData.statusName}}</span>
            </div>
          </li>
          <li class="details_body_row">
            <div style="flex:2">
              <span>外出时间：</span>
              <span>{{outManageData.outTime}}</span>
            </div>
            <div>
              <span>预计返回：</span>
              <span>{{outManageData.planReturnTime}}</span>
            </div>
          </li>
          <li class="details_body_row">
            <div>
              <span>事<span style="visibility:hidden;">占位</span>由：</span>
              <span>{{outManageData.outDemo}}</span>
            </div>
          </li>
          <li class="details_body_row">
            <div style="flex:2">
              <span>返回时间：</span><span>{{outManageData.returnTime}}</span>
            </div>
            <div>
              <span>实际用时：</span>
<!--              <span>时<span style="visibility:hidden;">占位</span>长：</span>-->
              <span v-if="outManageData.outNumber">{{outManageData.outNumber}}</span>
            </div>
          </li>
          <li class="details_body_row">
            <div>
              <span>备<span style="visibility:hidden;">占位</span>注：</span>
              <span>{{outManageData.outResult}}</span>
            </div>
          </li>
          <li class="details_body_row">
            <div>
              <span>附<span style="visibility:hidden;">占位</span>件：</span>
              <span><img :src="'http://'+item" alt="附件" style="width:130px;height:90px;padding:0 4px;" v-for="(item,index) in outManageData.pictureIds" :key="index"></span>
            </div>
          </li>
        </ul>
        <div class="details_body" v-if="isActiveNum==1">
          <el-table :data="outManageLog" border style="width: 100%;" highlight-current-row :header-cell-style="setHeaderStyle">
            <el-table-column prop="operationName" label="操作人"></el-table-column>
            <el-table-column prop="operationTime" label="操作时间"></el-table-column>
            <el-table-column prop="content" label="操作内容"></el-table-column>
            <el-table-column prop="location" label="定位"></el-table-column>
          </el-table>
          <div class="footer_page">
            <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total1"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import { queryGoout, employeeQuery, queryOutManageDetail, queryOutLog ,departmentFind} from "@/api/manageCenter";
import { getRouterLevel } from "@/vue/util/tool";
export default {
  name: "/goOutManage",
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      departpopshow: false,
      defaultProps: {
        children: "child"
      },
      departmentList: [], //门店列表
      permisList,
      isRowColor: "",
      imgListShow: false,
      imgList: [],
      dialogVisible: false,
      tabTitle: [
        { name: "基本信息" },
        { name: "操作日志" }
      ],
      isActiveNum: 0,
      outManageId: "",//外出ID
      outManageData: {},//外出详情
      outManageLog: [],//外出日志

      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "本季度",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      employeesList: [], //员工列表
      statusList: [
        { name: "不限", value: "" },
        { name: "未返回", value: "OUT" },
        { name: "已返回", value: "RETURN" },
      ],//审批状态列表

      goOutLsit: [], //黑名单列表
      pageNumber: 1,
      pageSize: 20,
      currentPage: 1,
      total: 0,
      pageNumber1: 1,
      pageSize1: 20,
      currentPage1: 1,
      total1: 0,

      searchData: {
        outTime: "",//时间
        employeeName: "",
        employeeId: "", //录入人
        status: "",//审批状态
        shopId:'',
        shopname:'',

      }, //搜索列表
    };
  },

  inject: ['ispc'],

  mounted() {
    this.getGooutlist();//查询外出列表
    this.getdepartmentFindAll();
  },
  activated() {
    this.getGooutlist();//查询外出列表
  },
  watch: {
    isActiveNum(val) {
      if (val == 0) {
        this.getOutManageDetail();
      } else if (val == 1) {
        this.pageNumber1 = 1;
        this.pageSize1 = 20;
        this.currentPage1 = 1;
        this.total1 = 0;
        this.getOutLog();
      }
    }
  },
  methods: {
    // 门店
    getdepartmentFindAll() {
      // 获取部门
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.departmentList = res.data;
        }
      });
    },
    handleNodeClick(node, data) {
      //cosole.log(node)
      this.searchData.shopId = node.id;
      this.searchData.shopname = node.name;
      // this.getsigner();
      this.currentPage=1;
      this.pageNumber=1;
      this.getGooutlist();
      this.departpopshow = false;
    },
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
    //修改当前行字体颜色
    rowColorclick(row) {
      this.isRowColor = row.id;
    },
    //图片放大
    openImglist(data) {
      if (data.pictureIds.length > 0) {
        this.imgList = data.pictureIds;
        this.imgListShow = true;
      }
    },
    downLoadImg(item) {
      // 下载图片
      sessionStorage.setItem("downImg", item);
      this.$electron.ipcRenderer.send("open-directory-dialog");
    },
    //查看外出详情
    toDetails(row) {
      if (row.id) {
        this.outManageId = row.id
        this.getOutManageDetail();
        this.isActiveNum = 0;
        this.dialogVisible = true;
      }
    },
    //外出详情
    getOutManageDetail() {
      let params = {
        id: this.outManageId
      }
      this.$post(queryOutManageDetail, params).then(res => {
        if (res.success) {
          this.outManageData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },
    //外出日志
    getOutLog() {
      let params = {
        id: this.outManageId,
        "page.pageNumber": this.pageNumber1 * this.pageSize1 - this.pageSize1,
        "page.pageSize": this.pageSize1
      }
      this.$post(queryOutLog, params).then(res => {
        if (res.success) {
          this.outManageLog = res.data;
          this.total1 = res.total;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },
    //查询外出列表
    getGooutlist() {
      this.isRowColor = "";
      let params = {
        shopId:this.searchData.shopId,
        outTime: this.searchData.outTime,
        employeeId: this.searchData.employeeId,
        status: this.searchData.status,
        permissionLevel: getRouterLevel("外出查看"),
        "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize
      };
      this.$post(queryGoout, params).then(res => {
        if (res.success) {
          this.goOutLsit = res.data;
          this.total = res.total;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGooutlist(); //当前页
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getGooutlist(); //当前页
    },
    //分页
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getOutLog()
    },
    handleCurrentChange1(val) {
      this.pageNumber1 = val;
      this.getOutLog()
    },
    querySearchAsync(queryString, cb) {
      let params = {
        name: queryString,
        status:'ENABLE',
        departmentId:this.searchData.shopId
      };

      this.$post(employeeQuery, params).then(res => {
        if (res.success) {
          if (res.data.length<=0){
            this.$message.error('该部门下没有人员！');
          }
          this.employeesList = res.data;
          let restaurants = this.employeesList;
          cb(restaurants);
          if (!this.searchData.employeeName) {
            this.searchData.employeeId = '';
            // this.currentPage = 1;
            // this.pageNumber = 1;
            this.getGooutlist()
          }

        } else {
        }
      });
    },
    handleSelect(item) {
      this.searchData.employeeId = item.id;
      this.searchData.employeeName = item.name;
      this.currentPage = 1;
      this.pageNumber = 1;
      this.getGooutlist()
    },
  },
};
</script>
<style type="text/css" lang="less">
.goOutManage {
  height: 100%;
  .departpop {
    width: 170px;
    position: absolute;
    left: 30px;
    top: 41px;
    z-index: 10;
    border: 1px solid #eee;
    .tree-item {
      display: flex;
      align-items: center;
      img {
        padding-right: 10px;
      }
    }
  }
  .el-button {
    background: #999999;
    color: #ffffff;
  }
  .el-button--primary {
    background: #5e75e6;
  }
  .el-dialog__header {
    margin-bottom: 10px;
    .el-dialog__title {
      color: #5e75e6;
      font-size: 20px;
    }
  }
  .el-dialog__body {
    margin: 0 40px 30px 40px;
  }
  .sales_header {
    background: white;
    position: relative;

    .chouse_wrap {
      display: flex;
      height: 60px;
      align-items: center;
      .conditions_list {
        display: flex;
        > p {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 10px;
          font-size: 14px;
          color: #bbb;

          .icon-xiajiantou {
            &.active {
              transform: rotate(180deg);
            }
          }

          > span {
            padding-left: 5px;
          }
        }

        .conditions_list_item {
          display: flex;
          align-items: center;
          margin-left: 20px;
          > span {
            font-size: 12px;
            color: #666;
            min-width: 24px;
          }
          .Residential {
            .el-input__inner {
              width: 140px;
              height: 30px;
              border: 1px solid #dbdbdb;
            }
          }
          .Residential1 {
            .el-input__inner {
              width: 200px;
              height: 30px;
              border: 1px solid #dbdbdb;
            }
          }
          .el-select {
            .el-input {
              .el-input__inner {
                width: 120px;
                height: 30px;
                border: 1px solid #dbdbdb;
              }

              .el-input__icon {
                line-height: 30px;
              }
            }
          }

          .el-input-group {
            .el-input-group__append {
              padding: 0 19px;
              background: #5e75e6;

              .icon-icon_sousuo {
                color: white;
              }
            }

            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              padding-left: 0;
              border: none;
              width: 120px;
            }
          }

          &.total_price_input {
            display: flex;
            height: 30px;

            .total_inp {
              display: flex;
              align-items: center;
              border: none;

              .el-range-editor.el-input__inner {
                height: 30px;
                line-height: 30px;
                .el-range-separator {
                  height: 30px;
                  line-height: 30px;
                }
                .el-input__icon {
                  height: 30px;
                  line-height: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2800;
    .close {
      width: 20px;
      position: absolute;
      top: 0;
      right: 300px;
      padding: 50px;
      z-index: 100;
    }
    .delet {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 100px;
      z-index: 100;
      height: auto !important;
    }
    .edit {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 240px;
      z-index: 100;
      height: auto !important;
    }

    .el-carousel__container {
      margin: 0 auto;
      width: 80%;
      height: 90vh;
      z-index: 99;
      .el-carousel__arrow {
        font-size: 50px !important;
        padding: 20px;
        width: 100px;
        height: 100px;
      }
    }
  }
  .details_contant {
    .details_title {
      display: flex;
      &_item {
        width: 106px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #ff9065;
        color: #ff9065;
        cursor: pointer;
        font-size: 16px;
      }
      .isActive {
        background: #ff9065;
        color: #fff;
      }
    }
    .details_body {
      margin-top: 20px;
      font-size: 14px;
      &_row {
        display: flex;
        margin-bottom: 20px;
        > div {
          flex: 1;
          display: flex;
        }
      }
    }
  }
}
</style>
